import { render } from "./LayoutEmpty.vue?vue&type=template&id=c3267e58"
import script from "./LayoutEmpty.vue?vue&type=script&lang=js"
export * from "./LayoutEmpty.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/LayoutEmpty.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c3267e58"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c3267e58', __exports__)) {
    api.reload('c3267e58', __exports__)
  }
  
  module.hot.accept("./LayoutEmpty.vue?vue&type=template&id=c3267e58", () => {
    api.rerender('c3267e58', render)
  })

}


export default __exports__